// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"361":"688e26af","763":"b0b90180","797":"97ceb544"}[chunkId] + ".css";
};